<template>
  <div>
    <section-header
      :title="$t('faq.title')"
      :media="require('rhomtrip_assets/src/img/home/back-circle-two.png')"
      styleBack="sm"
    ></section-header>

    <section class="section-six alileft">
      <div class="container">
        <div class="row">
          <div class="col-lg-3" data-aos="fade-right">
            <h2 class="max-title">{{ $t("faq.h2") }}</h2>
            <p v-html="$t('faq.p1')"></p>
            <p v-html="$t('faq.p2')"></p>
          </div>
          <div class="col-lg-9" data-aos="fade">
            <collapse>
              <collapse-item
                type="show"
                :name="index"
                v-for="(point, index) in $t('faq.questions')"
                :key="index"
                :title="point.q"
                icon="flaticon-question"
              >
                <div>
                  <p v-html="point.a"></p>
                  <p v-html="point.a1"></p>
                  <ul>
                    <li v-for="(points, index) in point.li" :key="index">
                      <p v-html="points.p"></p>
                    </li>
                  </ul>
                </div>
              </collapse-item>
            </collapse>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "faq",
  data() {
    return {
      metaTagParams: {
        titlePage: "FAQ | Rhomtrip",
        descriptionPage:
          "If you have any questions, in our frequently asked questions you will find the answers",
        patchImg: require("rhomtrip_assets/src/img/headers/faq-rhomtrip.jpg"),
        imgAlt: "faq",
        imgType: "image/jpg",
        langPage: "en_US",
        keywords: "faq,frecuent,questions,answers",
        url:
          window.location.pathname === "/"
            ? `${window.location.origin}`
            : `${window.location.origin}${window.location.pathname}`,
        thumbnail: require("rhomtrip_assets/src/img/headers/faq-rhomtrip.jpg")
      }
    };
  },

  methods: {
    ...mapActions([""]),
    ...mapMutations(["setMetaTags"])
  },

  computed: {
    ...mapGetters(["metaTags"])
  },

  mounted() {
    this.setMetaTags(this.metaTagParams);
  },

  metaInfo() {
    return this.metaTags;
  }
};
</script>
